<template>
  <b-modal id="privacy-policy-modal"
           title="Privacy Policy"
           size="lg"
           scrollable
  >
    <h4>WHAT THIS PRIVACY POLICY COVERS</h4>
    <p>
      The Association of American Railroads, Inc. (“AAR”)
      takes your privacy seriously. Please read the
      following to learn more about our privacy policy.
    </p>
    <p>
      The federal government and technology industry have
      developed practical tips to help you guard against
      Internet fraud, secure your computer and protect
      your personal information.
    </p>
    <h4>HOW AAR USES YOUR PERSONAL INFORMATION</h4>
    <p>
      This policy covers how AAR treats personal
      information that AAR collects and receives,
      including information related to your past use of
      AAR products and services. Personal information is
      information about you that is personally
      identifiable like your name, address, email address,
      or phone number, and that is not otherwise publicly
      available.
    </p>
    <p>This privacy policy only applies to AAR.</p>
    <p>
      This policy does not apply to the practices of
      companies other than AAR or to people that AAR does
      not employ or manage.
    </p>
    <h4>INFORMATION COLLECTION AND USE</h4>
    <h6>General</h6>
    <p>
      AAR collects personal information when you register
      with AAR, when you purchase AAR products or
      services, and when you visit AAR pages.
    </p>
    <p>
      When you register we ask for information such as
      your name, email address, and the name of the AAR
      member company that is your employer. When you
      register with AAR and sign in to our services, you
      are not anonymous to us. If you decide to purchase
      any services or products from AAR, we may need to
      collect your credit card information to bill you for
      these services or products. AAR does not store your
      credit card information; therefore, you must
      re-input your credit card information each time you
      place an order using our online forms.
    </p>
    <p>
      AAR uses data tracking software to collect
      information about activities on our site on an
      aggregate basis. AAR uses the information to track
      which pages of the site are most frequently
      requested to help us improve the site in the future.
    </p>
    <h4>CHILDREN</h4>
    <p>
      AAR does not target or sell products for purchase by
      children. You must be 18 years of age or older to
      register with AAR or place orders online.
    </p>
    <h4>INFORMATION SHARING AND DISCLOSURE</h4>
    <p>
      AAR does not rent, sell, or share personal
      information about you with other people or
      non-affiliated companies except to provide products
      or services you've requested, when we have your
      permission, or under the following circumstances:
    </p>
    <p>
      We respond to subpoenas, court orders, or legal
      process (such as law enforcement requests), or to
      establish or exercise our legal rights or defend
      against legal claims.
    </p>
    <p>
      We believe it is necessary to share information in
      order to investigate, prevent, or take action
      regarding illegal activities, suspected fraud,
      situations involving potential threats to the
      physical safety of any person, violations of AAR's
      terms of use, or as otherwise required by law.
    </p>
    <p>
      We transfer information about you if AAR is acquired
      by or merged with another company. In this event,
      AAR will notify you before information about you is
      transferred and becomes subject to a different
      privacy policy.
    </p>
    <p>
      We process information collected through our site
      for the purposes of:
    </p>
    <p>
      Administering and fulfilling order and accounts
      relating to customers, subscribers, or suppliers
    </p>
    <p>Identifying potential customers or subscribers</p>
    <p>
      Conducting market research surveys and other
      activities related to internal business analysis
    </p>
    <p>
      Providing you with information about our products or
      services we offer independently or jointly with or
      on behalf of other organizations.
    </p>
    <h4>COOKIES AND SIMILAR TECHNOLOGIES</h4>
    <p>
      AAR and its affiliates may set and access cookies to
      provide you with customized information about
      offerings that support your specific business needs.
      A cookie is an element of data that a web site can
      send to your browser, which may then be stored on
      your computer’s hard drive so we can recognize you
      when you return. You may set your browser to notify
      you when you receive a cookie.
    </p>
    <p>
      <strong>
        Your Ability to Update and to Delete Your
        Account Information
      </strong>
    </p>
    <p>
      AAR does not collect, hold, use or communicate your
      personal information unless you have given consent
      to use your information for the purposes specified
      by AAR in this policy. You can choose not to
      disclose certain information to us, such as your
      name and e-mail address. However, if you choose not
      to disclose your name and e-mail address, you will
      not be able to register with AAR, thus limited your
      access to certain portions of the site. Furthermore,
      your use of some of the applications and services
      may also be restricted if you chose not to disclose
      information necessary for billing purposes.
    </p>
    <p>
      You may change your information at any time. You can
      update your personal information by selecting
      “update my profile” after selecting “log in.” You
      may delete your AAR account by contacting us at
      <b-link href="mailto:support@railmessages.com">
        support@railmessages.com
      </b-link>
      .
    </p>
    <h4>CONFIDENTIALITY AND SECURITY</h4>
    <p>
      We limit access to personal information about you to
      employees who we believe reasonably need to come
      into contact with that information to provide
      products or services to you or in order to do their
      jobs.
    </p>
    <p>
      We have physical, electronic, and procedural
      safeguards that comply with federal regulations to
      protect personal information about you.
    </p>
    <h4>CHANGES TO THIS PRIVACY POLICY</h4>
    <p>
      AAR may update this policy. We may notify you about
      significant changes in the way we treat personal
      information by sending a notice to the primary email
      address specified in your AAR account or by placing
      a prominent notice on our site.
    </p>
    <h4>QUESTIONS AND SUGGESTIONS</h4>
    <p>
      If you have questions or suggestions, you can
      contact us at legal@aar.org or by mail to:
    </p>
    <p>
      Association of American Railroads <br/>
      425 3rd Street SW, Ste. 1000 <br/>
      Washington, DC 20024
    </p>
    <p>
      This Agreement governs the relationship between the
      Association of American Railroads, Inc.,
      (hereinafter "AAR") and any visitor, customer,
      licensor, supplier and/or member of AAR (hereinafter
      "you") with respect to use of the AAR website
      (hereinafter "the Site").
    </p>
    <p>
      By accessing and viewing/using the Site, you
      acknowledge that you have read, understand and agree
      to be bound by the terms and conditions stated, or
      incorporated by reference, in this Agreement.
    </p>
    <h4>ACCURACY OF INFORMATION</h4>
    <p>
      AAR may, at its sole discretion, at any time make
      corrections, improvements and changes to the
      information, terms, service(s), software or other
      product(s) provided or described in the Site. Any
      changes made will be effective automatically without
      further or special notice. Your continued use of the
      Site following such changes will be deemed
      acceptance of such changes. Be sure to return to
      this page periodically to ensure familiarity with
      the most current version of this Agreement. AAR
      makes no warranties or representations as to the
      accuracy of such information.
    </p>
    <h4>DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITIES</h4>
    <p>
      The information provided by the Site is provided
      without any representations or warranties -- whether
      implied, express or statutory. AAR does not warrant
      that the Site will be error or virus free. AAR does
      not assume any liability whatsoever arising out of
      your use of, or reliance on, the Site, regardless of
      whether negligence on the part of AAR may have
      caused or contributed to any loss or damage suffered
      by you as a result of using or relying upon the
      Site. In no event under any theory of law, whether
      contract, tort, warranty or otherwise, shall AAR
      have any liability whatsoever to you for damages of
      any kind, as a result of your use of the Site. You
      agree that you waive, and will not bring, any claim,
      demand or suit against AAR or any of its officers,
      directors, employees or affiliates arising out of
      your use of the Site or reliance on any information
      contained in or linked to the Site.
      <strong>
        AAR SPECIFICALLY DISCLAIMS ANY WARRANTIES,
        EXPRESS OR IMPLIED, WITH REGARD TO THIS SITE,
        ITS SOFTWARE AND THE INFORMATION PROVIDED
        THROUGH THE SITE, INCLUDING BUT NOT LIMITED TO
        WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A
        PARTICULAR PURPOSE.
      </strong>
    </p>
    <h4>SITE USER LICENSING</h4>
    <p>
      AAR reserves the right to prohibit you from
      accessing the Site at any time with or without
      cause, at its sole discretion. Your access to the
      Site constitutes a revocable, nonexclusive limited
      license to access the Site under the terms and
      conditions of this agreement.
    </p>
    <p>
      Any unauthorized downloading, retransmission,
      republication or other copying or modification of
      material posted on the Site, including trademarks,
      trade names and service marks, may violate federal,
      common or civil law trademark law and copyright law,
      is prohibited and may result in legal action.
    </p>
    <p>
      If you download software from the Site, such
      software is licensed on a limited basis to you by
      AAR or the owner of such software. Title to the
      software is not transferred to you. AAR retains all
      rights, title and interest in and to the software,
      and all intellectual property rights therein.
    </p>
    <p>
      AAR reserves the right to require you to delete,
      destroy or otherwise remove any content that is used
      in a manner that in AAR's opinion is contrary to
      this Agreement. You agree that any person to whom
      you supply the content will be advised of the terms
      and conditions of this Agreement, and that each such
      person is bound by these terms and conditions. You
      may in no way modify, reformulate, adapt, alter,
      adjust, change, disassemble, frame or decrypt any of
      the materials on the Site.
    </p>
    <h4>COPYRIGHTS AND TRADEMARKS</h4>
    <p>
      The trademarks, logos and service marks owned by
      AAR, whether registered or unregistered, may not be
      used in connection with any product or service
      unless AAR expressly grants such a right via a
      licensing agreement, which AAR may decline to do for
      any reason. Nothing contained on the Site should be
      construed as granting, by implication, estoppel or
      otherwise, any license or right to use any trademark
      without the express written permission of AAR, its
      licensors or suppliers, or the third party owner of
      any such trademark, which may be refused for any
      reason. Unauthorized usage of any trademark is
      prohibited, and AAR will aggressively enforce its
      intellectual property rights including but not
      limited to judicial remedies.
    </p>
    <h4>PERSONAL INFORMATION AND DISCLOSURE STATEMENT</h4>
    <p>
      Any personal information provided by
      customers/visitors to the Site is used for AAR's
      internal purposes only. AAR does not plan to
      divulge, sell or lease any personal information,
      customer listings or aggregate data gathered through
      the Site to any third party. However, be aware that
      other web sites that may be accessed through the
      Site may collect personally identifiable information
      about you. The information practices of those third
      party sites linked to AAR are not covered by this
      privacy statement nor are they related to or
      controlled by AAR.
    </p>
    <p>
      Corporate and securities laws supersede the
      information disclosed or otherwise available in,
      through or on the Site. These laws must not be
      qualified, amended, modified or supplemented by the
      information disclosed on the Site. AAR makes no
      representation that materials or information
      available on the Site are appropriate or available
      for use in specific jurisdictions, and accessing
      them from jurisdictions where their contents are
      illegal is prohibited.
    </p>
    <h4>GOVERNING LEGAL JURISDICTION</h4>
    <p>
      The AAR website is controlled by AAR from its
      offices in Washington, DC. By accessing the Site,
      you agree that all matters relating to your use of
      the Site shall be governed by the laws of the
      District of Columbia. You also agree to the
      exclusive personal jurisdiction and venue of the
      courts of the District of Columbia with regard to
      such matters.
    </p>
    <template #modal-footer="{ ok }">
      <b-button size="sm"
                variant="outline-primary"
                v-on:click="ok()"
      >
        OK
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'PrivacyPolicyModal'
}
</script>
